import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { assets } from '../../core/constants/assets.const';

@Component({
  selector: 'xplora-website-success',
  imports: [MatDialogModule, TranslateModule, MatIconModule],
  templateUrl: './success.component.html',
  standalone: true
})
export class SuccessComponent {
  assetsConst = assets;

  constructor(
    private MatDialogRef: MatDialogRef<SuccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { becomeMember: boolean }
  ) {}

  close(): void {
    this.MatDialogRef.close(false);
  }

  continue(): void {
    this.MatDialogRef.close(true);
  }
}
